var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLcrInScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41.0664,
    width: 24.0758,
    height: 18.9597,
    rx: 5,
    fill: "#FDC043"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 24.0758,
    height: 18.9597,
    rx: 5,
    fill: "#FDC043"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2134,
    y: 41.0664,
    width: 6.31989,
    height: 9.32937,
    fill: "#ED9D0A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9121,
    y: 20,
    width: 6.31989,
    height: 9.32937,
    fill: "#ED9D0A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.1855,
    y: 32.124,
    width: 19.196,
    height: 19.196,
    rx: 4,
    fill: "#1E5292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8661 37.1753H41.54V39.6629",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6855 37.1753H55.2701V39.6629",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2168 41.6016H55.3671",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4434 44.0889V46.3503H44.351",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3347 43.9922V46.2537H53.4609",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0288 39.1138V41.1814",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.709 39.1138V41.1814",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3892 39.1138V41.1814",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0371 39.1138V41.1814",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7168 39.1138V41.1814",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0288 42.5381V44.6057",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.709 42.5381V44.6057",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3892 42.5381V44.6057",
    stroke: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0371 42.5381V44.6057",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7168 42.5381V44.6057",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5078 41.6016H55.3028",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.3368,
    cy: 48.727,
    r: 4.66299,
    fill: "#32C52F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6869 48.8934L53.6737 50.2477L57.6357 47.5019",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcrInScan);
export default __webpack_public_path__ + "static/media/lcr-in-scan.6e9f46a41b4a04815710d0dcc4d73d1e.svg";
export { ForwardRef as ReactComponent };